import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStageLayoutDeferredErrorVO {
  private static validation = JsonSchemaValidator.compile(
    RoomStageLayoutDeferredErrorVO.validationSchema()
  );

  constructor(readonly value: RoomStageLayoutDeferredError) {
    JsonSchemaValidator.assert(
      RoomStageLayoutDeferredErrorVO.validation,
      value
    );
  }

  toString() {
    return `${this.value.message} (${this.value.code}, ${this.value.errorId})`;
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["code", "message"],
      properties: {
        code: {
          type: "number",
          minimum: 0,
          maximum: Number.MAX_SAFE_INTEGER
        },
        message: {
          type: "string",
          minLength: 0,
          maxLength: 2_048
        },
        errorId: {
          type: "string",
          format: "uuid"
        }
      }
    };
  }
}

interface RoomStageLayoutDeferredError {
  code: number;
  message: string;
  errorId?: string;
}
